<template>
  <div
    v-if="show && $page.props._flashStatus"
    class="mx-5 mt-4 mb-2 flex rounded-lg border border-brand-500 bg-white px-4 py-2 text-brand-500 shadow-lg print:hidden"
  >
    <div class="flex-1">
      {{ $page.props._flashStatus.message }}
    </div>
    <button class="-mr-2 px-2" @click="show = false">
      <span class="fal fa-times" />
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: true,
    }
  },
  watch: {
    '$page.props._flashStatus': {
      handler() {
        this.show = true
      },
      deep: true,
    },
  },
}
</script>
